import { isPossiblePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js'

export function validatePhoneNumber(phone: string | undefined) {
  if (!phone) return true

  const checkLengthAndPrefix =
    (phone.charAt(0) === '1' && phone.length === 13) ||
    (phone.charAt(0) !== '1' && phone.length === 12)

  return isPossiblePhoneNumber(phone) && (!checkLengthAndPrefix || isValidPhoneNumber(phone, 'US'))
}
